import { BlotterFeedType } from "@/pages/Blotter/services/blotterApi";
import { ORDER_EVENT, POSITION_UPDATE, BALANCE_UPDATE, ASSET_MARGIN_REPORT, POSITION_MARGIN_REPORT, TRADE_EVENT, TRANSFER_EVENT } from "@/pages/Blotter/services/consts";
import { IAGBlotterDataRow } from "../../AlgoTable.types";
import { IExecutionReport, ITradeCaptureReport } from "@pulse-ui/codegen/generated_ts/drop_copy";
import { IAssetMarginReport, IBalanceReport, IPositionMarginReport, ITradingPositionReport, ITransferReport } from "@pulse-ui/codegen/generated_ts/position_management";
import { mapOrderEvent } from "./orderEvent";
import { mapPositionUpdate } from "./positionUpdate";
import { mapBalanceUpdate } from "./balanceUpdate";
import { mapAssetMarginReport } from "./assetMarginReport";
import { mapPositionMarginReport } from "./positionMarginReport";
import { mapTradeEvent } from "./tradeEvent";
import { mapTransferEvent } from "./transferEvent";

export function mapRowData(rawData: any[], feedType: BlotterFeedType): IAGBlotterDataRow[] {
    if (!rawData?.length) return [];
    switch (feedType) {
        case ORDER_EVENT:
            return (rawData as IExecutionReport[]).map(mapOrderEvent);
        case POSITION_UPDATE:
            return (rawData as ITradingPositionReport[]).map(mapPositionUpdate);
        case BALANCE_UPDATE:
            return (rawData as IBalanceReport[]).map(mapBalanceUpdate);
        case ASSET_MARGIN_REPORT:
            return (rawData as IAssetMarginReport[]).map(mapAssetMarginReport);
        case POSITION_MARGIN_REPORT:
            return (rawData as IPositionMarginReport[]).map(mapPositionMarginReport);
        case TRADE_EVENT:
            return (rawData as ITradeCaptureReport[]).map(mapTradeEvent);
        case TRANSFER_EVENT:
            return (rawData as ITransferReport[]).map(mapTransferEvent);
        default:
            return [];
    }
}